/*
 * @Author: zhangxiaoda zhangxiaoda@nextmar.com
 * @Date: 2025-04-14 11:02:50
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-11-27 14:49:37
 * @FilePath: /src/api/order.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { httpRequest, type HttpRequestTransportOptions } from '@/utils/axios';
import { TIKTOK_CLICK_ID_STORAGE_KEY } from '@/utils/ad-click-attribution-constants';
import { getSetLocalStorage } from '@/utils/tools';
import { ensureTongDunLoaded, getTongDunBlackBox } from '@/utils/tongdunScript';
import type {
  GuestCreatePayload,
  GuestCreateResponse,
} from '@/domain/payment/guest-checkout/order';
import type { GuestAddressRequest } from '@/domain/payment/guest-checkout/guest-address';
import type { GuestPriceRequest } from '@/domain/payment/guest-checkout/price';
import type { ApiParamsDefinition } from './types/api-definition';
import { ICreateOrderParams, IGetTrackOrderParams, IOrderList, IPriceParams } from './types/order';

// 订单 ID 是路径参数，可能是超长数字字符串或含字母，不能统一转 number。
export type OrderPathId = string | number;

type GeneratedTrackOrderParams = ApiParamsDefinition['GET:/api/order/track_new/{order_id}'];
type GeneratedOrderDetailParams = ApiParamsDefinition['GET:/api/order/details/{order_id}'];
type GeneratedOrderChangeParams = ApiParamsDefinition['GET:/api/order/mj_workorder']['params'];

type GuestApiRequest = <Response>(
  url: string,
  params: { data: unknown },
  toastConfig: { success: boolean; fail: boolean },
  axiosParams: HttpRequestTransportOptions,
) => Promise<Response>;

const requestGuestApi = httpRequest as unknown as GuestApiRequest;

const GUEST_REQUEST_OPTIONS: HttpRequestTransportOptions = { skipAuth: true };
const SILENT_TOAST_OPTIONS = { success: false, fail: false };

// OpenAPI 生成类型暂为 number，这里只在 wrapper 内局部兼容真实路径参数。
const trackOrderPathParams = (order_id: OrderPathId, page: number) =>
  ({ order_id, params: { page } }) as unknown as GeneratedTrackOrderParams;

const orderDetailPathParams = (order_id: OrderPathId) =>
  ({ order_id }) as unknown as GeneratedOrderDetailParams;

function getCurrentUrlTtclid(): string | undefined {
  if (typeof window === 'undefined') return undefined;

  return new URLSearchParams(window.location?.search ?? '')
    .getAll('ttclid')
    .find((value) => value.trim())
    ?.trim();
}

function getOrderTtclid(): string | undefined {
  const currentUrlTtclid = getCurrentUrlTtclid();
  if (currentUrlTtclid) return currentUrlTtclid;
  if (typeof window === 'undefined') return undefined;

  const latestChannelAttribute = window.latestChannelAttribute;
  const source = latestChannelAttribute?.pub_zl_utm_source;
  const isValidTiktokChannel =
    latestChannelAttribute?.expires > Date.now() &&
    typeof source === 'string' &&
    source.toLowerCase().includes('tiktok');

  if (!isValidTiktokChannel) return undefined;

  const storedTtclid = getSetLocalStorage.get(TIKTOK_CLICK_ID_STORAGE_KEY);
  return typeof storedTtclid === 'string' && storedTtclid.trim() ? storedTtclid.trim() : undefined;
}

export const reorder = (data: { order_id?: number }) =>
  httpRequest('POST:/api/order/reorder', { data }, { success: true, fail: true });

/**
 * 获取订单跟踪信息
 * @param data 包含订单ID和页面标识
 */
export const trackOrder = (data: { order_id: OrderPathId; page: string }) => {
  // 只归一化 page，order_id 必须保留原始值，避免长订单号精度丢失或变成 NaN。
  const page = Number(data.page) || 1;

  return httpRequest(
    'GET:/api/order/track_new/{order_id}',
    trackOrderPathParams(data.order_id, page),
  );
};

// 获取个状态订单数量
export const getOrderStatistics = () => httpRequest('GET:/api/order/statistics');

// 获取订单列表
export const fetchOrderList = (data: IOrderList) =>
  httpRequest('GET:/api/order/lists', { params: data });

// 获取已评论的列表
export const fetchReviewList = (data: { page: number; limit: number }) =>
  httpRequest('GET:/api/order/review', { params: data });

// 获取订单详情
export const fetchOrderDetail = (orderId: OrderPathId) =>
  httpRequest('GET:/api/order/details/{order_id}', orderDetailPathParams(orderId));

// 获取订单详情页推荐商品
export const fetchOrderDetailRecommendProducts = (
  orderId: OrderPathId,
  params?: { waterfall_position?: number },
) =>
  // 推荐接口也使用订单 ID 路径参数，可能来自订单详情返回值，保持原样透传。
  httpRequest('GET:/api/order/details/{order_id}/recommend_products' as any, {
    order_id: orderId,
    params,
  });

// 修改评论
export const updateReview = (data: any) =>
  httpRequest('POST:/api/order/update_review', {
    data,
  });

// 发表评论
export const postReview = (data: any) =>
  httpRequest('POST:/api/order/product_review', {
    data,
  });

// 订单详情
export const orderDetail = (order_id: OrderPathId) =>
  httpRequest('GET:/api/order/details/{order_id}', orderDetailPathParams(order_id));

// 更新订单项处方图片
export const updateOrderItemPrescriptionsImage = (data: any) =>
  httpRequest('POST:/api/order/update_order_item_prescriptions_image', {
    data,
  });

// 获取订单变更记录
export const orderChangeListAction = (params: GeneratedOrderChangeParams) =>
  httpRequest('GET:/api/order/mj_workorder', { params });

// 修改地址
export const modifyAddress = (data: any) =>
  httpRequest('POST:/api/order/modify_address', {
    data,
  });

// 计价
export const getPriceForPayment = (params: IPriceParams) =>
  httpRequest('GET:/api/order/price', { params }, { success: false, fail: false });

export const getPriceForGuestPayment = (
  data: GuestPriceRequest,
): ReturnType<typeof getPriceForPayment> =>
  requestGuestApi<Awaited<ReturnType<typeof getPriceForPayment>>>(
    'POST:/api/order/guest_price',
    { data },
    SILENT_TOAST_OPTIONS,
    GUEST_REQUEST_OPTIONS,
  );

export const precheckGuestAddressForPayment = (data: GuestAddressRequest): Promise<unknown> =>
  requestGuestApi<unknown>(
    'POST:/api/order/guest_address',
    { data },
    SILENT_TOAST_OPTIONS,
    GUEST_REQUEST_OPTIONS,
  );

// 创建订单
export const createOrderForPayment = async (data: ICreateOrderParams) => {
  // 确保同盾脚本已加载（延迟加载，不影响 TBT）
  await ensureTongDunLoaded();
  const latestChannelAttribute =
    typeof window !== 'undefined' ? window.latestChannelAttribute : undefined;
  const isLatestChannelAttributeValid = latestChannelAttribute?.expires > Date.now();
  const ttclid = getOrderTtclid();

  return httpRequest(
    'POST:/api/order/create',
    {
      data: {
        ...data,
        utm_info: {
          pub_zl_utm_source: isLatestChannelAttributeValid
            ? latestChannelAttribute?.pub_zl_utm_source || undefined
            : undefined,
          pub_zl_utm_medium: isLatestChannelAttributeValid
            ? latestChannelAttribute?.pub_zl_utm_medium || undefined
            : undefined,
          pub_zl_utm_campaign: isLatestChannelAttributeValid
            ? latestChannelAttribute?.pub_zl_utm_campaign || undefined
            : undefined,
          pub_zl_utm_campaignid: isLatestChannelAttributeValid
            ? latestChannelAttribute?.pub_zl_utm_campaignid || undefined
            : undefined,
          pub_zl_referrer: isLatestChannelAttributeValid
            ? latestChannelAttribute?.pub_zl_referrer || undefined
            : undefined,
          pub_zl_page:
            isLatestChannelAttributeValid || latestChannelAttribute?.expires === -1
              ? latestChannelAttribute?.pub_zl_page || undefined
              : undefined,
          pub_landing_page: latestChannelAttribute?.pub_landing_page || undefined,
          ...(ttclid ? { ttclid } : {}),
        },
        black_box: getTongDunBlackBox(),
      },
    },
    { success: false, fail: false },
  );
};

export const createOrderForGuestPayment = async (
  data: GuestCreatePayload,
): Promise<GuestCreateResponse> => {
  await ensureTongDunLoaded();

  return requestGuestApi<GuestCreateResponse>(
    'POST:/api/order/guest_create',
    {
      data: {
        ...data,
        black_box: data.black_box || getTongDunBlackBox(),
      },
    },
    SILENT_TOAST_OPTIONS,
    GUEST_REQUEST_OPTIONS,
  );
};

// 补差价下单
export const createDiffOrder = (data: any) =>
  httpRequest('POST:/api/public/difference', { data }, { success: false, fail: false });

// 根据邮箱/订单号 查询物流
export const getTrackOrder = (data: IGetTrackOrderParams) =>
  httpRequest('POST:/api/public/get_type_track', { data });

// track order 页面获取订单列表
export const getTrackOrderList = (data: { limit: number; page: number; track_order: number }) =>
  // @ts-ignore TODO: 已提给后端修改，后续更新api file 自动修复
  httpRequest('GET:/api/order/track_order_list', { data });

export const downLoadInvoicePdf = (data: {
  params: {
    /** 订单id */
    order_id?: string;
  };

  data: Record<string, any>;
}) => {
  return httpRequest(
    'GET:/api/order/download_pdf_invoice',
    { params: data.params, data: data.data },
    { success: false, fail: false },
    {
      responseType: 'blob',
    },
  );
};
